import {
  assign, find, findIndex, forEach, get, isEmpty, isNull, remove, set, sortBy, cloneDeep,
} from 'lodash';
import { TimeFormatType } from '../../common/components/TimeFormat/TimeFormat';
import { SET_SELECTED_DEMO_CHARGERS } from './components/DeliveredEnergy/constants';

const defaultState = {
  powerMonitoring: {
    timeOffsetType: TimeFormatType.USER,
    chargers: {
      loaded: [],
      selected: [],
    },
    chargerMetrics: [],
    selectedDemoChargers: [],
  },
};

const plain = (metrics) => {
  const plainResult = {};

  forEach(metrics, (m) => {
    plainResult[m.ts] = get(m, 'meter_values.POWER_W', 0);
  });

  return plainResult;
};

const convertToMetric = (charger) => ({
  chargerUuid: charger.chargerUuid,
  metrics: plain(charger.metrics),
  loading: charger.loading,
});

export const ReportsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_POWER_MONITORING_LOADED_CHARGERS': {
      const sorted = sortBy(action.payload, 'uuid');

      return set(cloneDeep(state), 'powerMonitoring.chargers.loaded', sorted);
    }
    case 'SET_POWER_MONITORING_SELECTED_CHARGERS': {
      const newState = cloneDeep(state);
      const selected = get(newState, 'powerMonitoring.chargers.selected');
      const chargerMetrics = get(newState, 'powerMonitoring.chargerMetrics');

      remove(chargerMetrics, (metric) => findIndex(selected, (charger) => charger.uuid === metric.chargerUuid) === -1);

      return set(newState, 'powerMonitoring.chargers.selected', action.payload);
    }
    case 'SET_POWER_MONITORING_CHARGER_METRICS': {
      const newState = cloneDeep(state);
      const metrics = [];

      if (!isNull(action.payload)) {
        forEach(action.payload, (charger) => {
          metrics.push(convertToMetric(charger));
        });
      }

      return set(newState, 'powerMonitoring.chargerMetrics', metrics);
    }

    case 'MERGE_POWER_MONITORING_CHARGER_METRICS': {
      const newState = cloneDeep(state);
      const metrics = get(newState, 'powerMonitoring.chargerMetrics');

      if (metrics) {
        forEach(action.payload, (charger) => {
          let chargerMetric = find(metrics, { chargerUuid: charger.chargerUuid });

          if (isEmpty(chargerMetric)) {
            chargerMetric = convertToMetric(charger);
            metrics.push(chargerMetric);
          } else {
            assign(chargerMetric.metrics, plain(charger.metrics));
          }

          if (charger.loading) {
            chargerMetric.loading = charger.loading;
          }
        });
      }

      return set(newState, 'powerMonitoring.chargerMetrics', metrics);
    }

    case 'SET_POWER_MONITORING_TIME_OFFSET_TYPE':
      return set(cloneDeep(state), 'powerMonitoring.timeOffsetType', action.payload);

    case SET_SELECTED_DEMO_CHARGERS:
      return { ...state, selectedDemoChargers: action.payload };

    case 'SET_SHOW_RETRY_ICON_ON_SELECTED_CHARGERS': {
      const { chargerIds, value } = action.payload;
      const selectedChargers = get(state, 'powerMonitoring.chargers.selected', []);

      selectedChargers.forEach((charger) => {
        if (chargerIds.indexOf(charger.uuid) > -1) {
          charger.isError = value;
        }
      });

      return {
        ...state,
        powerMonitoring: {
          ...state.powerMonitoring,
          chargers:
            {
              ...state.powerMonitoring.chargers,
              selected:
                [...selectedChargers],
            },
        },
      };
    }

    default:
      return state;
  }
};

export default ReportsReducer;
